import { render, staticRenderFns } from "./sell-order-form.vue?vue&type=template&id=51ba0d50&"
import script from "./sell-order-form.vue?vue&type=script&lang=js&"
export * from "./sell-order-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports